var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDeveloperCommunityGithub1 = function SvgDeveloperCommunityGithub1(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2,0,0,2,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.41,22.35a.5.5,0,0,0,.64.48,11.25,11.25,0,1,0-6.24,0,.5.5,0,0,0,.64-.48V20A2.81,2.81,0,0,1,6,18.28,6.07,6.07,0,0,0,4.64,16c2.85.69,2.9,2.54,4.84,1.67a4,4,0,0,1,.63-1.82c-2.2-.25-4.52-.6-4.52-4.4a3.84,3.84,0,0,1,1-2.66,3.56,3.56,0,0,1,.1-2.62s.83-.27,2.73,1a9.39,9.39,0,0,1,5,0c1.89-1.28,2.72-1,2.72-1a3.56,3.56,0,0,1,.1,2.62,3.83,3.83,0,0,1,1,2.66c0,3.81-2.32,4.15-4.53,4.39a3.83,3.83,0,0,1,.68,2.33Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDeveloperCommunityGithub1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "developer-community-github-1.34989b38eec4334eb83e176de77f7404.svg";